export default class AfterCallsSelector {
  public static selectIsLoading(state: ReduxState) {
    return state.afterCall.isLoading;
  }
}
